<template>
  <div class="blockC matching-box clearfix" style="margin-top: 20px">
    <div class="blockC-detail">
      <div class="blockC-tip"></div>
      <span class="blockC-title">托运人信息：</span>
      <RadioGroup class="radioGroup" style="margin-left: 20px;" v-model="formData.palletType" @on-change="changeRadio">
        <Radio :label="1" v-show="showComp">平台企业</Radio>
        <Radio :label="2" v-show="showUser" :style="showComp ? 'margin-left: 20px;':''">企业用户</Radio>
        <Radio :label="3" v-show="showUser" style="margin-left: 20px;">个人</Radio>
      </RadioGroup>
    </div>
    <vxe-form
        style="margin-top: 10px;"
        ref="buyer"
        class="my-form"
        title-align="right"
        :data="formData"
        :rules="chooseComp ? formRules2 : (formData.palletType === 2 ? formRules : formRules1)"
        title-width="120"
        prevent-submit>
      <vxe-form-item title="平台企业名称" field="pallet" span="8" v-if="formData.palletType === 1">
        <template>
          <div :class="compCheck ? 'input-border border-red' : 'input-border'">
            <platform-corp
                class="corp"
                :row="formData"
                :field="'pallet'"
                :isDefault="true"
                :placeholder="'请选择平台企业'"
                @select="selectComp"
            ></platform-corp>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="开户行" field="palletBank" span="8" v-if="formData.palletType === 1">
        <template v-slot="scope">
          <vxe-input v-model="formData.palletBank" placeholder="请输入开户行" clearable
                     @input="$refs.buyer.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="账号" field="palletAccount" span="8" v-if="formData.palletType === 1">
        <template v-slot="scope">
          <vxe-input v-model="formData.palletAccount" placeholder="请输入账号" clearable
                     @input="$refs.buyer.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="企业名称" field="palletName" span="16" v-if="formData.palletType === 2">
        <template>
          <vxe-pulldown class="vxe-pulldown--content" ref="compDown1" transfer>
            <template v-slot>
              <vxe-input v-model="formData.palletName" placeholder="请输入企业名称"
                         @input="inputEvent"></vxe-input>
            </template>
            <template v-slot:dropdown>
              <div class="chainId-dropdown">
                <vxe-grid
                    border="none"
                    highlight-hover-row
                    auto-resize
                    height="auto"
                    :loading="compLoading"
                    :data="tableData"
                    :columns="columns"
                    @cell-click="cellClick"
                ></vxe-grid>
              </div>
            </template>
          </vxe-pulldown>
        </template>
      </vxe-form-item>
      <vxe-form-item title="个人名称" field="palletName" span="16" v-if="formData.palletType === 3">
        <template v-slot="scope">
          <vxe-input v-model="formData.palletName" placeholder="请输入签约方姓名" clearable
                     @input="$refs.buyer.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="手机号" field="palletPhone" span="8"
                     v-if="formData.palletType === 2 || formData.palletType === 3">
        <template v-slot="scope">
          <vxe-input v-model="formData.palletPhone" :placeholder="chooseComp ? '选填' : '必填'" clearable
                     @input="$refs.buyer.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="开户行" field="palletBank" span="16"
                     v-if="formData.palletType === 2 || formData.palletType === 3">
        <template v-slot="scope">
          <vxe-input v-model="formData.palletBank" placeholder="请输入开户行" clearable
                     @input="$refs.buyer.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="账号" field="palletAccount" span="8"
                     v-if="formData.palletType === 2 || formData.palletType === 3">
        <template v-slot="scope">
          <vxe-input v-model="formData.palletAccount" placeholder="请输入账号" clearable
                     @input="$refs.buyer.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
    </vxe-form>
  </div>
</template>

<script>
  import PlatformCorp from "@/components/common/PlatformCorp";
  import $api from '@/apiProvider';

  export default {
    props: ['shipperType', 'isSubmit', 'isCancel', 'isSave', 'detailData'],
    components: {PlatformCorp},
    data() {
      const number = ({itemValue}) => {
        if (itemValue && itemValue !== "") {
          let reg = /^\d+(?=\.{0,1}\d+$|$)/;
          if (!reg.test(itemValue)) {
            return Promise.reject(new Error("请输入正确的数字"));
          }
        }
      };
      return {
        showComp: true,
        showUser: true,
        formData: {
          pallet: null,
          palletId: null,
          palletType: null,
          palletName: null,
          palletBank: null,
          palletAccount: null,
          palletPhone: null
        },
        formRules2: {
          palletName: [{required: true, message: "请输入企业名称"}],
          palletAccount: [{validator: number}],
        },
        formRules1: {
          pallet: [{required: true, message: "请选择平台企业"}],
          palletName: [{required: true, message: "请输入个人姓名"}],
          palletPhone: [{required: true, message: "请输入手机号"}, {min: 11, max: 11, message: "请输入正确的手机号"}],
          palletAccount: [{validator: number}],
        },
        formRules: {
          pallet: [{required: true, message: "请选择平台企业"}],
          palletName: [{required: true, message: "请输入企业名称"}],
          palletPhone: [{required: true, message: "请输入手机号"}, {min: 11, max: 11, message: "请输入正确的手机号"}],
          palletAccount: [{validator: number}],
        },
        tableData: [],
        columns: [{field: "compName", title: "企业名称"}, {field: "regisiterNum", title: "手机号"}], // 选择平台企业下拉框数据列
        compLoading: false,
        chooseComp: false,
        compCheck: false,
      }
    },
    watch: {
      shipperType(val) {
        if (val === 1) {
          this.formData.pallet = null;
          this.formData.palletId = null;
          this.formData.palletName = null;
          this.formData.palletPhone = null;
          this.formData.palletBank = null;
          this.formData.palletAccount = null;
          this.formData.palletType = 2;
          this.showComp = false;
          this.showUser = true;
        } else {
          this.showComp = true;
          if (this.formData.palletType === 1) {
            if (val === 2 || val === 3) {
              return
            }
            this.showUser = true;
          } else {
            this.formData.palletType = 1;
            this.formData.pallet = null;
            this.formData.palletId = null;
            this.formData.palletName = null;
            this.formData.palletPhone = null;
            this.formData.palletBank = null;
            this.formData.palletAccount = null;
            this.showUser = false;
          }
        }
      },
      isSubmit(val) {
        if (val) {
          this.check();
        }
      },
      isCancel(val) {
        if (val) {
          this.reset();
        }
      },
      isSave(val) {
        if (val) {
          this.setParams();
        }
      },
      detailData(val) {
        if (val) {
          if (this.detailData.shipperType === 1) {
            if (this.detailData.secondPartyIsPlat === 1) {
              this.chooseComp = true;
            }
            this.showComp = false;
            this.showUser = true;
          } else {
            this.showComp = true;
            if (this.detailData.palletType === 1) {
              this.showUser = true;
            } else {
              this.formData.palletType = 1;
              this.showUser = false;
            }
          }
          this.formData = {
            palletId: this.detailData.palletId,
            palletType: this.detailData.palletType,
            pallet: this.detailData.palletName,
            palletName: this.detailData.palletName,
            palletBank: this.detailData.palletBank,
            palletAccount: this.detailData.palletAccount,
            palletPhone: this.detailData.palletPhone
          }
        }
      }
    },
    methods: {
      async check() {
        const errMap = await this.$refs.buyer.validate().catch(errMap => errMap);
        if (errMap) {
          if (!this.formData.pallet || this.formData.pallet === '') {
            this.compCheck = true;
          } else {
            this.compCheck = false;
          }
          this.$emit("setParams", false);
          return
        }
        this.compCheck = false;
        this.setParams();
      },
      setParams() {
        // 过滤参数
        let obj = {
          palletId: this.formData.palletId,
          palletType: this.formData.palletType,
          palletName: this.formData.palletName,
          palletBank: this.formData.palletBank,
          palletAccount: this.formData.palletAccount,
          palletPhone: this.formData.palletPhone
        };
        this.$emit("setParams", obj);
      },
      changeRadio(val) {
        this.$emit("setPalletType", val);
        this.formData.pallet = null;
        this.formData.palletName = null;
        this.formData.palletBank = null;
        this.formData.palletAccount = null;
        this.formData.palletPhone = null;
        this.chooseComp = false;
        this.clearValidate();
      },
      selectComp(bool, index, row) {
        this.formData.palletName = index.pallet;
        this.formData.palletBank = row.bankName;
        this.formData.palletAccount = row.accountNum;
        this.clearValidate();
      },
      focusEvent() {
        if (this.formData.palletName) {
          this.$refs.compDown1.showPanel();
          this.queryUserList(this.formData.palletName)
        }
      },
      inputEvent(val) {
        this.chooseComp = false;
        if (val && val !== '') {
          this.chooseComp = false;
          this.$refs.compDown1.showPanel();
          this.queryUserList(val)
        }
      },
      cellClick({row}) {
        this.clearValidate();
        if (row.aboutCompId) {
          this.chooseComp = true;
        } else {
          this.chooseComp = false;
        }
        this.formData.palletName = row.compName;
        this.formData.palletPhone = row.regisiterNum;
        this.formData.palletBank = row.bankName;
        this.formData.palletAccount = row.accountNum;
        this.$refs.compDown1.hidePanel();
      },
      async queryUserList(val) {
        this.compLoading = true;
        let res = await $api.baseUserSign.post("queryUserList", {
          page: 1,
          rows: 1000,
          username: val,
          userType: 2
        });
        this.compLoading = false;
        if (res.status === 1) {
          this.tableData = res.data.rows;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      clearValidate() {
        this.$refs.buyer.clearValidate();
        this.compCheck = false;
      },
      reset() {
        this.formData = {
          palletType: null,
          palletName: null,
          palletBank: null,
          palletAccount: null,
          palletPhone: null
        };
        this.chooseComp = false;
        this.clearValidate();
      }
    }
  };
</script>

<style scoped>
  .input-border {
    display: flex;
    align-items: center;
    height: 100%;
    box-sizing: border-box;
    padding-left: 10px;
    border: 1px solid #f2f1f1;
  }

  .input-border >>> .link-text {
    color: #438DF3;
  }

  .border-red {
    border-color: #f56c6c;
  }

  .my-dropdown1 {
    height: 200px;
    overflow: auto;
    border-radius: 4px;
    background-color: #fff;
    border: 1px solid #dcdfe6;
  }

  .list-item1:hover {
    background-color: #f5f7fa;
  }

  .vxe-pulldown--content {
    width: 100%;
  }

  .corp >>> .link-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 180px !important;
  }
</style>